<template>
  <div class="promotion-teaser" @click="delegateClick">
    <slot/>
  </div>
</template>

<script>
import { getPath, getLinkInPath } from '@/assets/js/helper/dom'
import { getNamedParentContext } from '@/assets/js/helper/vm'

import GtmPromotionImpressions from '@/components/public/special/GtmPromotionImpressions'

export default {
  name: 'PromotionTeaser',
  props: {
    promoId: {
      type: String,
      default: null
    },
    promoName: {
      type: String,
      default: null
    },
    promoCreative: {
      type: String,
      default: null
    },
    promoPosition: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      destroy: false
    }
  },
  computed: {
    isPromotion () {
      return this.promoId !== null && this.promoName !== null
    },
    isClone () {
      return getPath(this.$el).some(element => element.classList.contains('slick-cloned'))
    }
  },
  methods: {
    delegateClick (e) {
      if (this.isPromotion) {
        const link = getLinkInPath(getPath(e.target))

        if (link && this.$store.getters['gtm/isAvailable']) {
          e.preventDefault()

          this.$store.dispatch('gtm/promotionClick', {
            promotion: {
              id: this.promoId,
              name: this.promoName,
              creative: this.promoCreative,
              position: this.promoPosition
            },
            callback: () => {
              link.dispatchEvent(new MouseEvent('click', { ctrlKey: e.ctrlKey, shiftKey: e.shiftKey, altKey: e.altKey }))
            }
          })
        }
      }
    }
  },
  beforeCreate () {
    this.promotionImpressionsContext = getNamedParentContext(GtmPromotionImpressions.name, this)
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isPromotion && !this.isClone && !this.destroy) {
        this.promotionImpressionsContext.$emit('gtm:registration', {
          id: this.promoId,
          name: this.promoName,
          creative: this.promoCreative,
          position: this.promoPosition
        })
      }
    })
  },
  beforeDestroy () {
    this.destroy = true
  }
}
</script>
